import { get, post } from './Utility';

export async function getOasisData(referralId) {
  let oData = await get(`/api/Referral/Map/${referralId}`);
  return oData.resgg;
}
export async function getSections() {
  return await get('/api/referral/getsections');
}
export async function getFileNames(referralId) {
  var fileNamesResponse = await get(`/api/Referral/getFileNames/${referralId}`);
  if (fileNamesResponse !== undefined) {
    return fileNamesResponse.fileNames;
  }
  return [];
}
export async function getCommentCards(referralId, fileName) {
  return await get(`/api/Referral/getCommentCards/${referralId}/${fileName}`);
}
export async function postComment(vm) {
  return await post(`/api/Referral/postComment`, vm);
}
export async function getUserReferralSummary() {
  return await get(`/api/Patient/GetReferralsSummary`);
}

export async function searchUserReferral(searchTerm) {
  const response = await get(`/api/Patient/searchUserReferral/${searchTerm}`);
  return response;
}
